/* eslint-disable no-param-reassign */
import tagService from "src/services/tagService";

export const GET_LIST_TAG_REQUEST = "@tag/get-list-tag-request";
export const GET_LIST_TAG_SUCCESS = "@tag/get-list-tag-success";
export const GET_LIST_TAG_FAILURE = "@tag/get-list-tag-failure";

export const GET_TAG_REQUEST = "@tag/get-tag-request";
export const GET_TAG_SUCCESS = "@tag/get-tag-success";
export const GET_TAG_FAILURE = "@tag/get-tag-failure";

export const ADD_TAG_REQUEST = "@tag/add-tag-request";
export const ADD_TAG_SUCCESS = "@tag/add-tag-success";
export const ADD_TAG_FAILURE = "@tag/add-tag-failure";

export const UPDATE_TAG_REQUEST = "@tag/udpate-tag-request";
export const UPDATE_TAG_SUCCESS = "@tag/udpate-tag-success";
export const UPDATE_TAG_FAILURE = "@tag/udpate-tag-failure";

export const DELETE_TAG_REQUEST = "@tag/delete-tag-request";
export const DELETE_TAG_SUCCESS = "@tag/delete-tag-success";
export const DELETE_TAG_FAILURE = "@tag/delete-tag-failure";

export const GET_LIST_TAG_TYPE_REQUEST = "@tag/get-list-tag-type-request";
export const GET_LIST_TAG_TYPE_SUCCESS = "@tag/get-list-tag-type-success";
export const GET_LIST_TAG_TYPE_FAILURE = "@tag/get-list-tag-type-failure";

export const CLEAR_TAG = "@tag/clear-tag";
export const CLEAR_LIST_TAG = "@tag/clear-list-tag";

export function getListTag(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_TAG_REQUEST});
      const response = await tagService.getListTag(data);
      dispatch({
        type: GET_LIST_TAG_SUCCESS,
        payload: {
          response: response.data.data,
          total: response.headers["x-total-items"]
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_TAG_FAILURE});
      throw error;
    }
  };
}

export function getTag(id) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_TAG_REQUEST});
      const response = await tagService.getTag(id);
      dispatch({
        type: GET_TAG_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_TAG_FAILURE});
      throw error;
    }
  };
}

export function addTag(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_TAG_REQUEST});
      const response = await tagService.createTag(data);
      dispatch({
        type: ADD_TAG_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_TAG_FAILURE});
      throw error;
    }
  };
}

export function updateTag(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_TAG_REQUEST});
      const response = await tagService.updateTag(data);
      dispatch({
        type: UPDATE_TAG_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_TAG_FAILURE});
      throw error;
    }
  };
}

export function deleteTag(id) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_TAG_REQUEST});
      const response = await tagService.deleteTag(id);
      dispatch({
        type: DELETE_TAG_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: DELETE_TAG_FAILURE});
      throw error;
    }
  };
}

export function getListTagType() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_TAG_TYPE_REQUEST});
      const response = await tagService.getListTagType();
      dispatch({
        type: GET_LIST_TAG_TYPE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_TAG_TYPE_FAILURE});
      throw error;
    }
  };
}

export function clearTag() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_TAG
    });
  };
}

export function clearListTag() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_LIST_TAG
    });
  };
}
